import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { VehicleCard } from "@/features/resources/VehicleCard";
import { CardNotFound, CardSkeleton } from "@/features/resources/CardScreens";
import { getVehicle, resourcesKeys } from "@/features/resources/resources.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

const SCREEN_LABEL = "Back-office Vehicle Card";

export const Route = createFileRoute("/_shell/transport-units/vehicles/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_transport_units") && !hasModule(context.session, "tms_resources_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: VehicleScreen,
});

function VehicleScreen() {
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const canEdit = session.roles.includes("admin") || hasModule(session, "tms_resources_write");

  const query = useQuery({ queryKey: resourcesKeys.vehicle(id), queryFn: () => getVehicle(id), retry: false });

  if (query.isPending) return <CardSkeleton screenLabel={SCREEN_LABEL} />;
  if (query.isError || !query.data) return <CardNotFound screenLabel={SCREEN_LABEL} />;

  return (
    <div className="wl-page" data-screen-label={SCREEN_LABEL}>
      <VehicleCard key={query.data.id} vehicle={query.data} canEdit={canEdit} />
    </div>
  );
}
